import { ApiError } from './api-error';

/**
 * Read a failed request's message/code/details. The response interceptor
 * turns every HTTP error into an ApiError, so read that first and fall back
 * to the raw axios envelope for anything that bypassed it.
 */
interface RawShape {
  response?: {
    status?: number;
    data?: { error?: { code?: string; message?: string; details?: unknown } };
  };
}

export function apiErrorMessage(
  err: unknown,
  fallback = 'Something went wrong. Please try again.'
): string {
  if (err instanceof ApiError)
    return err.statusCode === 0
      ? 'You appear to be offline. Check your connection.'
      : err.message || fallback;
  return (err as RawShape | null)?.response?.data?.error?.message || fallback;
}

export function apiErrorCode(err: unknown): string | undefined {
  if (err instanceof ApiError) return err.code;
  return (err as RawShape | null)?.response?.data?.error?.code;
}

export function apiErrorDetails<T = Record<string, unknown>>(err: unknown): T | undefined {
  if (err instanceof ApiError) return err.details as T | undefined;
  return (err as RawShape | null)?.response?.data?.error?.details as T | undefined;
}
